import { RecentlyViewed } from '@theme/recently-viewed-products';

class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    this.renderProducts();
  }

  async renderProducts() {
    const currentProductId = String(this.dataset.currentProductId || '');
    const limit = Number(this.dataset.limit || 4);
    const productIds = RecentlyViewed.getProducts()
      .map(String)
      .filter((id) => id !== currentProductId)
      .slice(0, limit);

    if (productIds.length === 0) return;

    try {
      const url = new URL(`${window.Shopify.routes.root}search/suggest.json`, window.location.origin);
      url.searchParams.set('q', productIds.map((id) => `id:${id}`).join(' OR '));
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', String(limit));

      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;

      const payload = await response.json();
      const products = payload?.resources?.results?.products || [];
      const orderedProducts = productIds
        .map((id) => products.find((product) => String(product.id) === id))
        .filter(Boolean);

      if (orderedProducts.length === 0) return;

      const grid = this.querySelector('[data-recently-viewed-grid]');
      const template = this.querySelector('[data-recently-viewed-card]');
      if (!grid || !(template instanceof HTMLTemplateElement)) return;

      orderedProducts.forEach((product) => grid.append(this.createCard(template, product)));
      this.hidden = false;

      requestAnimationFrame(() => window.jdgm?.refreshWidgets?.());
    } catch (error) {
      console.warn('Recently viewed products could not be loaded.', error);
    }
  }

  createCard(template, product) {
    const card = template.content.cloneNode(true);
    const productUrl = product.url || `${window.Shopify.routes.root}products/${product.handle}`;

    card.querySelectorAll('[data-product-link]').forEach((link) => link.setAttribute('href', productUrl));

    const image = card.querySelector('[data-product-image]');
    if (image) {
      image.src = product.featured_image?.url || product.featured_image || '';
      image.alt = product.featured_image?.alt || product.title || '';
    }

    const title = card.querySelector('[data-product-title]');
    if (title) title.textContent = product.title || '';

    const price = card.querySelector('[data-product-price]');
    if (price) price.textContent = this.formatMoney(product.price);

    const rating = card.querySelector('[data-product-rating]');
    if (rating) rating.setAttribute('data-id', String(product.id));

    return card;
  }

  formatMoney(value) {
    if (typeof value === 'string' && /[^\d.,\s-]/.test(value)) return value;

    const numericValue = Number(value || 0);
    const amount = typeof value === 'string' && value.includes('.') ? numericValue : numericValue / 100;
    const currency = window.Shopify.currency?.active;

    if (currency) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        style: 'currency',
        currency,
      }).format(amount);
    }

    return `$${amount.toFixed(2)}`;
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
